import axios, { AxiosResponse } from 'axios';

import { AppConfig } from '../../config/appConfig';
import { CONFIG_FILE_URL } from '../consts/config-file-url';

export const getConfig = (): Promise<AxiosResponse<AppConfig>> => {
  return axios.get(CONFIG_FILE_URL);
};

const configAPI = {
  getConfig,
};

export default configAPI;
